<template>
  <div class="catalog">
    <div class="uk-grid uk-grid-match">
      <div class="uk-width-1-6@l uk-width-1-5@m uk-width-1-4@s uk-width-1-3" v-for="(card, i) in cards" :key="card.key">
        <a @click="openModal(i)">
          <Profile class="uk-margin-bottom" :card="card" :thumbnail="true"></Profile>
        </a>
      </div>
    </div>
    <!-- モーダルダイアログ 背景色なし -->
    <div ref="modal" uk-modal>
      <div class="uk-modal-dialog uk-modal-body">
        <!-- スライドショー -->
        <carousel :perPage="1" :navigationEnabled="true" :paginationEnabled="false"
                  :navigateTo="currentIndex">
          <slide v-for="(card) in cards" :key="card.key">
            <div class="padding-small">
              <Profile :card="card" :thumbnail="false"></Profile>
            </div>
          </slide>
        </carousel>
        <!-- 閉じるボタン -->
        <div class="uk-text-center">
          <a class="uk-modal-close uk-link-text">
            閉じる
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Profile from "@/components/Profile";
  import {Carousel, Slide} from 'vue-carousel';
  import UIkit from "uikit";

  export default {
    name: 'Catalog',
    components: { Profile, Carousel, Slide },
    data() {
      return {
        currentIndex: 0
      }
    },
    props: {
      cards: Array
    },
    mounted() {
    },
    methods: {
      openModal(index) {
        this.currentIndex = [index, false]; // ページ指定 falseはアニメーションなし
        UIkit.modal(this.$refs.modal).show();
      }
    }
  }
</script>
<style scoped>
  /* モーダルダイアログ 透明 サイズ制限 */
  .uk-modal-body {
    background: transparent;
    width: 300px;
    padding: 0;
  }

  .padding-small{
    padding: 5px;
  }

  /* モーダルダイアログ 閉じるボタン */
  .uk-modal-close{
    color: white;
  }
</style>
